<div>
  <div class="postion-relative">
    <div class="bannerContent position-relative">
      <div class="card innerDiv" (click)="dealVIEw(data)">
        <div class="image" style="position: relative">
          <div class="end-pro-time1 text-center mb-2" *ngIf="countDown">
            {{ countDown }}
          </div>

          <img
            class="img"
            [src]="data?.dealImage?.[0] || data?.thumbnail"
            (load)="onImageLoad()"
            [hidden]="!isLoaded"
            alt="categoryImage"
          />
          <ngx-skeleton-loader
            *ngIf="!isLoaded"
            [theme]="{ width: '227px', height: '260px', position: 'relative' }"
            count="1"
          ></ngx-skeleton-loader>
        </div>
        <div class="card-text-wrapper description-wrapper">
          <p class="description">{{ data?.serviceId?.serviceName }}</p>
        </div>
        <div class="card-text-wrapper" style="margin-top: -4px">
          <div class="row price-row">
            <div class="col-12 p-0 m-0">
              <p class="price">
                <span style="text-decoration: line-through">
                  <ng-container>
                    {{
                      data?.serviceId?.price &&
                        getPrice(
                          data?.serviceId?.price | currency : "ZAR" : "R"
                        )
                    }}
                  </ng-container>
                </span>
                <span class="price-color">
                  <ng-container>
                    {{
                      data?.dealPrice &&
                        getPrice(data?.dealPrice | currency : "ZAR" : "R")
                    }}
                  </ng-container>
                </span>
              </p>
            </div>
          </div>

          <div class="row deal-price-row" style="margin-top: -4px">
            <div class="col-12 p-0 m-0">
              <p class="dealPrice">
                Deal Discount :
                <span class="newn">
                  {{
                    getPrice(
                      ((data?.serviceId?.price - data?.dealPrice) / data?.serviceId?.price) * 100
                        | currency : "ZAR" : "R"
                    )
                  }}% off
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
